import React, { useState } from "react";
import request from 'request';
//import queryString from 'query-string';
import ReactQueryParams from 'react-query-params';
import ReactLoading from "react-loading";
import { useAuth0 } from "./react-auth0-wrapper";
import Loading from "./Loading";


var api_base_path = "https://api.api-university.com/v1";

const Transactions = () => {  
  const [token, setToken] = useState("");
  const [items, setItems] = useState([]);
  const [alreadyCalled, setAlreadyCalled] = useState(false);
  const [loading, setLoading] = useState(true);
  const { getTokenSilently } = useAuth0();

  const callApi = async () => {
    if (!alreadyCalled){
      setAlreadyCalled(true);
      try {
        const tokenSilent = await getTokenSilently();
        setToken(tokenSilent);
        console.log("got token");
        if (tokenSilent){
          var urlstr = api_base_path+'/bankdata/transactions';
          console.log("calling transactions");
          request({url:urlstr,headers:{'Authorization': `Bearer ${tokenSilent}`}}, function(err, res, body){
            setLoading(false);
            if (err) {
              console.log(err);
            } else if (res.statusCode === 200){
              console.log("got transactions");
              var bodyObj = JSON.parse(body);
              setItems(bodyObj);
            }
          });
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const callBla = () => {
    console.log("bla");
    return false;
  }

  const callSync = () => {
    try {
      setLoading(true);
      console.log("calling sync");
      var urlstr = api_base_path+'/callback?sync=true';
      request({url:urlstr,headers:{'Authorization': `Bearer ${token}`}}, function(err, res, body){
        setLoading(false);
        if (err) {
          console.log(err);
        } else if (res.statusCode < 400){
          console.log("synced");
          setAlreadyCalled(false);
          callApi();
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  const renderTransaction = (transaction) => {
    var account_link = "/accounts?accountid="+transaction.account_id;
    return (
      <tr className="table-row" key={transaction.transaction_id}>
        <td className="col account"><a href={account_link}><img src={transaction.account_img} alt={transaction.account_provider} tooltip={transaction.account_provider} height="14px"/></a></td>
        <td className="col timestamp">{new Date(transaction.timestamp).toDateString()}</td>
        <td className="col description">{transaction.description}</td>
        <td className="col amount">{transaction.amount}</td>
        <td className="col currency">{transaction.currency}</td>
      </tr>
    );
  }

  const renderTransactions = (transactionData) => {  
    var transactions_sorted = transactionData.sort(function(a,b){return new Date(b.timestamp) - new Date(a.timestamp)});
    var transactionItems = transactions_sorted.map(renderTransaction);
    return (
      <div><center>      
        <table className="supertable"><tbody>
          <tr className="table-header">
            <td className="col account">Account</td>
            <td className="col timestamp">Date</td>
            <td className="col description">Description</td>
            <td className="col amount">Amount</td>
            <td className="col currency">Currency</td>
          </tr>
          {transactionItems}
        </tbody></table>
      </center></div>      
    );
  }

  //TODO: this needs to go into contructor
  //console.log(tokenSilent);
  callApi();
  var transactions = renderTransactions(items);
  var loading_out = "";
  if (loading){
    loading_out = <Loading />;
  }  

  return (
    <div>
    <div className="searchBar">              
      <form onSubmit={(e) => {callSync(); e.preventDefault(); return false; }}>
        <button className="edit_button"  type="submit">sync</button>
      </form>
    </div><br/>
    {transactions}
    {loading_out}
  </div>
  );

}
export default Transactions;



// WEBPACK FOOTER //
// ./src/Transactions.js